import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const RFFeePaymentModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  feeAmount, onFeeAmountChange, feeAmountError, setFeeAmountError, feeAmountList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Bill processing fee payment'
    buttonLabel='Pay'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='feeAmount' label='Fee amount'
      value={feeAmount} onChange={onFeeAmountChange} optionList={feeAmountList}
      error={feeAmountError} setError={setFeeAmountError}
      help='18% GST will be added'
    />
  </ModalFormUI>

export default RFFeePaymentModalUI
